import React from 'react';
import { Tooltip } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import PublicIcon from '@material-ui/icons/Public';
import { isViewSharedWithUser } from 'store/explore/views';

// Public / Private / Shared indicator, used by both the ViewCard avatar and the open View's header
export const getViewPrivacyDisplay = (view, user) => {
  const isTempOrSystem = view?.id === 'temp' || view?.id === 'system';
  const isSharedWithMe = !isTempOrSystem && isViewSharedWithUser(view, user);
  const sharedWithCount = view?.sharedWithUsers?.length ?? 0;
  const tooltip = isSharedWithMe
    ? `Shared with you by ${view.createdBy ?? 'another user'}`
    : view?.privacy === 'Private' && sharedWithCount
      ? `Private, shared with ${sharedWithCount} user${sharedWithCount === 1 ? '' : 's'}`
      : view?.privacy ?? '';
  const Icon = view?.privacy === 'Public'
    ? PublicIcon
    : isSharedWithMe || sharedWithCount
      ? PeopleIcon
      : PersonIcon;
  return { isSharedWithMe, tooltip, Icon };
}

const ViewPrivacyIcon = ({ view, user, className, fontSize = 'small' }) => {
  const { tooltip, Icon } = getViewPrivacyDisplay(view, user);
  return (
    <Tooltip title={tooltip}>
      <Icon className={className} fontSize={fontSize} />
    </Tooltip>
  );
}

export default ViewPrivacyIcon;
